//font import
// import 'raleway-webfont';

//amcharts
// import * as am4core from "@amcharts/amcharts4/core";
// import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// Custom JS imports
import 'bootstrap';
import 'metismenu';
import 'node-waves';
import 'select2'
import 'bootstrap-datepicker'
// import 'datatables.net-responsive-bs4'

import './ms.js';

if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap.Tooltip && window.bootstrap.Tooltip.Default) {
    window.bootstrap.Tooltip.Default.container = 'body';
    window.bootstrap.Tooltip.Default.popperConfig = function (defaultBsPopperConfig) {
        return {
            ...defaultBsPopperConfig,
            strategy: 'fixed'
        };
    };
}

import { initTopbarSearch } from './modules/topbar_search';
import { initNotifications } from './modules/notifications';
import '../../assets/js/app.js';

// CSS imports
import 'toastr/build/toastr.css';
// choices
import '../../custom_node_modules/choices.js/public/assets/styles/choices.css';
import '../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap5.min.css';

// Custom CSS imports
import '../css/site.scss';
import '../../assets/scss/icons.scss';
import '../../assets/scss/app.scss';

console.log("The 'site' bundle has been loaded!");

initTopbarSearch();
initNotifications();

function applyTheme(theme, persistToServer = false) {
    const isDark = theme === 'dark';
    const link = document.getElementById('app-style');
    if (link) {
        const lightHref = link.getAttribute('data-app-light') || '/dist/site.css';
        const darkHref = link.getAttribute('data-app-dark') || '/dist/site-dark.css';
        link.href = isDark ? darkHref : lightHref;
    }

    if (isDark) {
        document.documentElement.setAttribute('data-bs-theme', 'dark');
        document.documentElement.setAttribute('data-layout-mode', 'dark');
        if (document.body) {
            document.body.setAttribute('data-layout-mode', 'dark');
        }
    } else {
        document.documentElement.setAttribute('data-bs-theme', 'light');
        document.documentElement.setAttribute('data-layout-mode', 'light');
        if (document.body) {
            document.body.setAttribute('data-layout-mode', 'light');
        }
    }

    try {
        localStorage.setItem('app-theme', theme);
        document.cookie = `app-theme=${theme}; path=/; max-age=31536000; SameSite=Lax`;
    } catch {}

    updateThemeUI(theme);

    window.dispatchEvent(new CustomEvent('app:theme-changed', {
        detail: { theme, isDark }
    }));

    if (persistToServer) {
        fetch('/Home/SetTheme', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ theme })
        }).catch(err => {
            console.warn('Failed to persist theme preference:', err);
        });
    }
}

function updateThemeUI(theme) {
    const isDark = theme === 'dark';
    const themeIcons = document.querySelectorAll('.js-theme-icon');
    for (const icon of themeIcons) {
        if (isDark) {
            icon.classList.remove('bx-moon');
            icon.classList.add('bx-sun');
        } else {
            icon.classList.remove('bx-sun');
            icon.classList.add('bx-moon');
        }
    }

    const themeTexts = document.querySelectorAll('.js-theme-text');
    for (const textEl of themeTexts) {
        const darkText = textEl.getAttribute('data-dark-text') || 'Dark Mode';
        const lightText = textEl.getAttribute('data-light-text') || 'Light Mode';
        textEl.textContent = isDark ? lightText : darkText;
    }
}

function initThemeManager() {
    let currentTheme = 'light';
    try {
        const match = document.cookie.match(/(?:^|; )app-theme=([^;]*)/);
        if (match) {
            currentTheme = decodeURIComponent(match[1]);
        }
        if (!currentTheme) {
            currentTheme = localStorage.getItem('app-theme') || 'light';
        }
    } catch {}

    applyTheme(currentTheme, false);

    document.addEventListener('click', (e) => {
        const toggleBtn = e.target.closest('.js-theme-toggle-btn');
        if (!toggleBtn) {
            return;
        }

        e.preventDefault();
        let activeTheme = 'light';
        try {
            activeTheme = localStorage.getItem('app-theme') || 'light';
        } catch {}

        const newTheme = activeTheme === 'dark' ? 'light' : 'dark';
        applyTheme(newTheme, true);
    });
}

initThemeManager();

function disableSearchAutocomplete() {
    const searchSelectors = [
        'input[type="search"]',
        'input[name="search"]',
        'input[name*="search" i]',
        'input[id*="search" i]'
    ];

    const searchInputs = document.querySelectorAll(searchSelectors.join(','));

    for (const input of searchInputs) {
        if ((input.type || '').toLowerCase() === 'hidden') {
            continue;
        }

        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');

        if (input.form) {
            input.form.setAttribute('autocomplete', 'off');
        }
    }
}

disableSearchAutocomplete();

// Restore scroll position on page reload/navigation
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'auto';
}
